const columns = [
  {
    name: 'Type',
    selector: (row) => row?.name,
  },
  {
    name: 'Event Count',
    selector: (row) => row?.eventcount,
  },
  {
    name: 'Incident Count',
    selector: (row) => row?.incidentcount,
  },
  {
    name: 'URL to Incident Percentage',
    selector: (row) => row?.percentage,
  },
]

export { columns };